import React from "react";
import { Box, Card, CardMedia, Container, Grid, Typography } from "@mui/material";
import ContactForm from "./ContactForm";
import HeaderBanner from "../../assets/others/contact-us.png";
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import ContactUsForm from "./ContactUsForm";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const ContactPage = () => {
  const location = useLocation();
  const canonicalUrl = `https://www.99gift.ae/${location.pathname}`;
  return (
    <React.Fragment>
      <Helmet>
        <title>Contact Us</title>
        <meta name="description" content="Contact Us - 99Gift" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content="Contact Us" />
        <meta property="og:description" content="Contact Us - 99Gift" />
        <link rel="canonical" href={canonicalUrl} />{" "}
        {/* Dynamic Canonical URL */}
      </Helmet>
      <Container maxWidth="xl">
        <PageBreadcrumb home="Home" currentProduct="Contact Us" />
      </Container>

      <Container maxWidth="false" sx={{ px: "0 !important" }}>
        <Card
          elevation={0}
          sx={{
            width: "100%",
            borderRadius: 0,
            overflow: "hidden",
          }}
        >
          <CardMedia
            component="img"
            image={HeaderBanner}
            alt="Header Banner"
            sx={{
              width: "100%",
              aspectRatio: {
                xs: "16 / 5.6",
                sm: "16 / 4",
                md: "16 / 4",
                lg: "16 / 4",
              },
              objectFit: "cover",
              display: "block",
            }}
          />
        </Card>
      </Container>

      <Grid
        container
        maxWidth="false"
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >


        <Grid
          item
          sm={9}
          lg={8}
          sx={{
            backgroundColor: "white.main",
            borderRadius: 2,
            mb: { xs: 3, sm: 6, lg: 8 },
          }}
        >
          <ContactUsForm />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ContactPage;
